<template>
    <div style="width:100%;height:100%;">
      <el-row :gutter="20" style="height:100%;">
        <el-col :span="12" style="height:100%;">
          <div class="title-box">
              部门管理
          </div>
          <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px;height:calc(100% - 100px);">
            <el-form-item prop="deptName">
              <el-input placeholder="搜索部门" v-model="queryParams.deptName"></el-input>
            </el-form-item>
            <!-- 添加按钮 -->
              <span v-hasPermi="['system:dept:add']" style="position:relative;float:right;">
                  <img src="~@/assets/images/add.png" @click="handleAdd()" style="margin-left:10px;cursor:pointer;"/>
              </span>
            <el-tree ref="tree" :data="deptList" :filter-node-method="filterNode" :expand-on-click-node="false" default-expand-all :props="{ value: 'deptId', label: 'deptName', children: 'children' }" node-key="deptId" @node-click="handleNodeClick" class="height: calc(100% - 60px);overflow-y: auto;">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>
                  <el-button v-hasPermi="['system:dept:add']" type="text" icon="el-icon-circle-plus-outline" @click="() => handleAdd(data)"></el-button>
                  <el-button v-hasPermi="['system:dept:edit']" type="text" icon="el-icon-edit" @click="() => handleUpdate(data)"></el-button>
                  <el-button v-hasPermi="['system:dept:remove']" type="text" icon="el-icon-delete" @click="() => handleDelete(data)"></el-button>
                </span>
              </span>
            </el-tree>
          </el-form>
        </el-col>
        <el-col :span="12" style="margin-top:58px;background:#fff;height: calc(100% - 100px);;border-radius:5px;">
          <!-- 部门管理功能操作示意图 -->
          <!-- <img src="../../assets/system/departHandel.jpg"/> -->
          <img src="@/assets/system/departHandel.jpg" />
        </el-col>
      </el-row>
      <!-- 添加 -->
      <el-dialog :visible.sync="dialogFormVisible" :title="dialogTitle" width="660px" center :close-on-click-modal="false">
        <el-form ref="deptFormRef" :model="form" :rules="rules" label-width="80px" style="padding:0;" :inline="true">
          <el-row>
            <el-col v-if="form.parentId !== 0" :span="24">
              <el-form-item label="上级部门" prop="parentId">
                <TreeSelect
                @parent-event="handleParentEvent"
                  v-model="form.parentId"
                  :options="deptOptions"
                  :objMap="{ value: 'deptId', label: 'deptName', children: 'children' }"
                  node-key="deptId"
                  placeholder="选择上级部门"
                  check-strictly
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="部门名称" prop="deptName">
                <el-input v-model="form.deptName" placeholder="请输入部门名称" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类别编码" prop="deptCategory">
                <el-input v-model="form.deptCategory" placeholder="请输入类别编码" clearable/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="显示排序" prop="orderNum">
                <el-input-number v-model="form.orderNum" controls-position="right" :min="0" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人" prop="leader">
                <el-select v-model="form.leader" placeholder="请选择负责人">
                  <el-option v-for="item in deptUserList" :key="item.userId" :label="item.userName" :value="item.userId" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入联系电话" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="form.email" placeholder="请输入邮箱" clearable/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="部门状态">
                <el-radio-group v-model="form.status">
                  <el-radio v-for="dict in sys_normal_disable" :key="dict.dictValue" :label="dict.dictValue">{{ dict.dictLabel }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="submitForm">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
</template>

<script>
import { handleTree } from '@/utils/base';
import { Message, MessageBox} from 'element-ui';
import { isValidPhone } from '@/utils/validate';
export default {
  components: {
    TreeSelect: () => import('@/components/FormComp/TreeSelect.vue')
  },
  watch: {
    'queryParams.deptName'(newVal) {
      this.$refs.tree.filter(newVal);
    }
  },
  data() {
    return {
      deptList: [],
      queryParams:{
        pageNum:1,
        pageSize: 10,
        deptName:""
      },
      // selectId:0,//选中部门id
      dialogFormVisible:false,
      dialogTitle:"",
      deptOptions:[],
      deptUserList:[],
      sys_normal_disable:[],
      form:{
        deptId: "",
        parentId: "",
        deptName: "",
        deptCategory: undefined,
        orderNum: 0,
        leader: undefined,
        phone: undefined,
        email: undefined,
        status: '0'
      },
      rules: {
        parentId: [{ required: true, message: '上级部门不能为空', trigger: 'blur' }],
        deptName: [{ required: true, message: '部门名称不能为空', trigger: 'blur' }],
        orderNum: [{ required: true, message: '显示排序不能为空', trigger: 'blur' }],
        email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }],
        phone: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' },
          { validator: this.validatePhone, message: '请输入正确的电话号码', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    // 查询系统开关
    getDisableDict(){
        this.$store.dispatch('dict/getDict', 'sys_normal_disable').then((result)=>{
            if(result?.data){
                this.sys_normal_disable = result.data;
            }
        });
    },
    validatePhone(rule, value, callback) {
      if(isValidPhone(value)){
          callback();
      }
      else{
        callback(new Error('请输入正确的电话号码'));
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      this.form.parentId = data.deptId;
    },
    // 查询部门
    getList(){
      this.$store.dispatch('dept/getDeptList', this.queryParams).then((result)=>{
          if(result){
            const data  = handleTree(result.data,'deptId');
            if(data){
              this.deptList = data;
            }
          }
      });
    },
    handleParentEvent(val){
      this.form.parentId = val+"";
    },
    // 提交按钮
    submitForm(){
      this.$refs["deptFormRef"].validate(async (valid) => {
        if (valid) {
          if(this.form.deptId){
            this.$store.dispatch('dept/updateDept',this.form).then(()=>{
              Message.success('操作成功');
              this.dialogFormVisible = false;
              this.getList();
            });
          }
          else{
            this.$store.dispatch('dept/addDept',this.form).then(()=>{
              Message.success('操作成功');
              this.dialogFormVisible = false;
              this.getList();
            });
          }
        }
      });
    },
    // 新增按钮
    handleAdd(nodeData){
      this.reset();
      //查询当前部门所有用户
      if(nodeData && nodeData.deptId){
        this.getDeptAllUser(nodeData.deptId);
      }
      else{
        this.getDeptAllUser("");
      }
      this.$store.dispatch('dept/getDeptList', this.queryParams).then((result)=>{
          if(result){
            const data  = handleTree(result.data,'deptId');
            if(data){
              this.deptOptions = data;
              if(nodeData && nodeData.deptId){
                this.form.parentId = nodeData.deptId;
              }
              this.dialogFormVisible = true;
              this.dialogTitle = "添加部门";
            }
          }
      });
    },
    // 删除按钮
    handleDelete(nodeData){
      MessageBox.confirm('是否确认删除名称为“' + nodeData.deptName + '”的数据项？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('dept/delDept',{deptId:nodeData.deptId}).then((result)=>{
          if(result){
              this.getList();
              Message.success('删除成功');
          }
        }); 
      }).catch(() => {          
      });
    },
    // 修改按钮
    handleUpdate(nodeData){
      this.reset();
      //查询当前部门所有用户
      this.getDeptAllUser(nodeData.deptId);
      // 查询部门详情
      this.$store.dispatch('dept/getDept', {deptId:nodeData.deptId}).then((result)=>{
          if(result){
            this.form = result.data;
            this.$store.dispatch('dept/listDeptExcludeChild',{deptId:nodeData.deptId}).then((res)=>{
              if(res){
                const data = handleTree(res.data,'deptId');
                if(data){
                  this.deptOptions = data;
                  if(data.length == 0){
                    this.deptOptions.push({
                      deptId: result.data.parentId,
                      deptName: result.data.parentName,
                      children: []
                    })
                  }
                }
                this.dialogFormVisible = true;
                this.dialogTitle = "修改部门";
              }
            });
          }
      });
    },
    /** 查询当前部门的所有用户 */
    getDeptAllUser(deptId){
      if (deptId !== null && deptId !== '' && deptId !== undefined) {
        this.$store.dispatch('user/listUserByDeptId', {deptId}).then((res)=>{
          this.deptUserList = res.data;
        });
      }
    },
    // 新增取消按钮
    cancel(){},
    // 重置表单
    reset(){
      this.form = {
        deptId: "",
        parentId: "",
        deptName: "",
        deptCategory: undefined,
        orderNum: 0,
        leader: undefined,
        phone: undefined,
        email: undefined,
        status: '0'
      };
    }
  },
  mounted(){
    this.getList();
    this.getDisableDict();
  }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
  .custom-tree-node{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .el-input-number{
    width:200px;
  }

  // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    .el-row{
        padding-bottom: 10px;
    }
    ::v-deep .el-form-item__error{
        padding-top: 0;
    }

  ::v-deep .el-dialog{
        border-radius: 5px;
  }
  ::v-deep .el-dialog__header {
      padding: 6px 19px;
      background: #B1CEF9;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
  }   
  ::v-deep .el-dialog__headerbtn {
      font-size: 18px;
  }
  ::v-deep .el-dialog__headerbtn {
      top: 10px;
      right: 6px;
  }
  ::v-deep .el-dialog__body {
      padding: 15px 20px;
      border-bottom: 1px solid #D5D5D5;
  }
  ::v-deep .el-form-item__label {
      font-size: 12px;
  }
  ::v-deep .el-dialog__footer {
      padding: 20px;
  }
</style>